import { LoggerUtil } from 'core/utils/loggerUtil.ts';

export function twitterAnalyticsUtil(eventId, eventData = {}) {
	if (window.twq) {
		window.twq('event', eventId, eventData);
	} else {
		LoggerUtil.logWarning("Twitter tracking 'twq' not found on window object");
	}
}
